<template>
  <div class="people-page" @click="handlePageClick($event)">
    <!-- MOTD Modal Component -->
    <MotdModal :route="$route.path" />

    <div class="title-bar">
      <span style="flex: 1">People Search</span>
      <div class="title-buttons">
        <button class="back-button" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i>
        </button>
        <button class="home" title="Home" @click="$router.push('/mhome')">
          <i class="fas fa-home"></i>
        </button>
      </div>
    </div>
    <div class="content-wrapper">
      <!-- Search Bar for tiles -->
      <div class="search-bar">
        <input
          ref="searchQuery"
          v-model="searchQuery"
          type="text"
          placeholder="Search here "
          class="search-input"
          style="font-size: 16px"
          @dblclick="clearSearch()"
          @focus="handleSearchFocus"
        />
        <div class="search-actions">
          <button
            :title="'clear search'"
            @click="clearSearch"
            class="clear-button"
          >
            <i class="fas fa-backspace"></i>
          </button>
          <button
            :title="'filter for active\ntenants only'"
            @click="showAll = !showAll"
            :class="{
              'active-class': showAll,
              'clear-button': true,
            }"
          >
            <i class="fas fa-eye-slash"></i>
          </button>
          <button
            :title="'Refresh list'"
            class="refresh-button"
            @click="fetchPeople(true)"
            :disabled="isRefreshing"
          >
            <i class="fas fa-refresh" :class="{ 'fa-spin': isRefreshing }"></i>
          </button>
          <span class="count-container">
            <label>sel: </label
            ><span class="count"> {{ formatNumber(rowCount, 0) }}</span>
          </span>
        </div>
      </div>
      <div
        style="
          margin-left: 3px;
          margin-top: 5px;
          margin-bottom: 0px;
          font-size: 0.8em;
        "
      >
        Search example: <small><b>121 Mad,Apt 3</b></small> or
        <small><b>456, Apt 2</b></small>
      </div>

      <div
        style="
          margin-left: 3px;
          margin-top: 5px;
          margin-bottom: 0px;
          font-size: 0.8em;
        "
      >
        Bracket filters: <small><b>[single]</b> or <b>[multi]</b></small>
      </div>

      <div
        style="
          margin-left: 3px;
          margin-top: 5px;
          margin-bottom: -3px;
          font-size: 0.8em;
        "
      >
        click to filter:
      </div>
      <div class="filter-buttons">
        <button
          :title="'filter by contacted'"
          :class="{ 'active-filter': filterContacted }"
          class="filter-button"
          @click="filterBy('contacted')"
        >
          <i class="fas fa-sign-out"></i>
        </button>
        <button
          :title="'filter by maintenance'"
          :class="{ 'active-filter': filterMaintenance }"
          class="filter-button"
          @click="filterBy('maintenance')"
        >
          <i class="fas fa-wrench"></i>
        </button>
        <button
          :title="'filter by email rcvd'"
          :class="{ 'active-filter': filterEmailed }"
          class="filter-button"
          @click="filterBy('emailed')"
        >
          <i class="fas fa-envelope"></i>
        </button>
        <button
          :title="'filter by payment'"
          :class="{ 'active-filter': filterPayment }"
          class="filter-button"
          @click="filterBy('payment')"
        >
          <i class="fas fa-money-check-dollar"></i>
        </button>
        <span class="separator"></span>
        <div class="sms-filter-stack">
          <button
            type="button"
            class="filter-button broadcast-alert"
            title="Broadcast"
            @click.stop="openTenantBroadcast"
          >
            <i class="fas fa-exclamation-triangle"></i>
          </button>
          <button
            :title="smsButtonTitle"
            class="filter-button sms-select-button"
            @click="bulkSMS"
            :class="{
              'active-sms': bulkSMSactive || smsSelectMode,
            }"
          >
            <i
              :class="
                smsSelectMode && !bulkSMSactive
                  ? 'fas fa-check-square'
                  : 'fas fa-sms'
              "
            ></i>
            <span
              v-if="smsSelectMode && !bulkSMSactive && smsSelectionCount > 0"
              class="sms-select-count"
              >{{ smsSelectionCount > 99 ? '99+' : smsSelectionCount }}</span
            >
          </button>
        </div>
      </div>

      <div v-if="showActiveNote" class="active-note floating-notification">
        Note: a person is automatically set to 'active' if they are assigned to
        a current lease. If a person was a tenant on a prior lease, you'll see
        multiple rows. Most recently contacted appears first.
      </div>

      <!-- Contacts as tiles -->
      <div :style="containerStyle" class="tiles-container">
        <div v-if="filteredPeople.length === 0" class="no-results-message">
          No match found.
          <span
            @click="searchQuery = ''"
            style="color: #a080a8; text-decoration: underline"
            >Clear</span
          >
          your search.
        </div>
        <div
          v-for="(person, index) in filteredPeople"
          :key="person.row_num"
          @dblclick="handleDoubleClick($event, person)"
          @click="selectCard($event, person, index)"
          :class="[
            'contact-tile',
            {
              'active-person': person.active === 1,
              'selected-tile':
                !smsSelectMode && selectedTileIndex === index,
              'sms-selected-tile': isSmsSelected(person),
            },
          ]"
          v-show="
            smsSelectMode ||
            bulkSMSactive ||
            selectedTileIndex === null ||
            selectedTileIndex === index
          "
        >
          <div class="tile-row tile-name">
            <span class="tile-name-main">
              {{ person.First }} {{ person.Last }}
              <span
                class="person-flag"
                :class="{ 'person-flag-on': personSmsOn(person) }"
                title="SMS opt-in"
              >S</span>
              <span
                class="person-flag"
                :class="{ 'person-flag-on': personNotifyOn(person) }"
                title="Chat notifications"
              >N</span>
            </span>
            <small class="activity-time">{{
              formatTimeAgo(person.mostRecentActivity)
            }}</small>
          </div>
          <div class="tile-row tile-email">Email: {{ person.Email }}</div>
          <div class="tile-row tile-phone">Phone: {{ person.Phone }}</div>
          <div class="tile-row tile-lease">
            Ends:
            {{
              (person.endsOn ? formatDate(person.endsOn) : '') +
              ' Rent: $' +
              Math.round(person.monthlyBaseRent) +
              ' (pets: ' +
              (person.petCount ? person.petCount : '0') +
              ')'
            }}
            <i
              v-if="person.dogCount > 0"
              class="fas fa-dog pet-icon"
              :style="{ color: petTemperamentColor(person.dogTemperament) }"
              :title="
                person.dogCount +
                ' dog(s) - ' +
                petTemperamentLabel(person.dogTemperament)
              "
            ></i>
            <i
              v-if="person.catCount > 0"
              class="fas fa-cat pet-icon"
              :style="{ color: petTemperamentColor(person.catTemperament) }"
              :title="
                person.catCount +
                ' cat(s) - ' +
                petTemperamentLabel(person.catTemperament)
              "
            ></i>
            <i
              v-if="person.petCount > 0 && !person.dogCount && !person.catCount"
              class="fas fa-paw pet-icon"
              style="color: #aaa"
              :title="
                person.petCount + ' pet(s) - edit lease to set dog/cat details'
              "
            ></i>
            <button
              v-if="person.shortCode"
              :style="{
                color: person.foreground,
                background: person.background,
                fontSize: '0.8em',
                borderRadius: '4px',
                border: `1px solid ${person.foreground}`,
                padding: '2px 6px',
                cursor: 'pointer',
                position: 'absolute',
                right: '18px',
              }"
              disabled
            >
              {{ person.shortCode }}
            </button>
          </div>
          <div class="tile-row tile-address">
            {{ person.Address }}
            <span class="specs-text">{{
              person.specs ? ' ' + person.specs : ''
            }}</span>
            <!-- eslint-disable-next-line prettier/prettier -->
            <div style="margin-top: 3px">
              {{
                'paid: $' +
                Math.round(person.latestPaymentAmount).toLocaleString('en-US')
              }}
              <span v-if="person.resignNewRent">
                {{
                  ' newR: $' +
                  Math.round(person.resignNewRent).toLocaleString('en-US')
                }}
              </span>
              <span
                v-if="person.currentLeaseBalance != null"
                class="tenant-bal"
                :class="
                  Number(person.currentLeaseBalance) < 0
                    ? 'tenant-bal-owed'
                    : 'tenant-bal-credit'
                "
              >
                {{
                  'bal: $' +
                  Math.round(person.currentLeaseBalance).toLocaleString(
                    'en-US',
                  )
                }}
              </span>
            </div>
          </div>
          <div class="utility-inclusions">
            <span class="utility-label">Incl:</span>
            <!-- Check if any utility is included -->
            <template
              v-if="
                person.includesElectric ||
                person.includesGas ||
                person.includesLawncare ||
                person.includesParkingSnowRemoval ||
                person.includesTrash ||
                person.includesWalkSnowRemoval ||
                person.includesWaterSewer
              "
            >
              <!-- `includesCableTV`, `includesElectric`, `includesGas`, `includesLawncare`, `includesParkingSnowRemoval`, `includesPhone`, `includesTrash`, `includesWalkSnowRemoval`, `includesWaterSewer` -->
              <div v-if="person.includesElectric" class="utility-tag">Elec</div>
              <div v-if="person.includesGas" class="utility-tag">Gas</div>
              <div v-if="person.includesLawncare" class="utility-tag">Lawn</div>
              <div v-if="person.includesParkingSnowRemoval" class="utility-tag">
                Park
              </div>
              <div v-if="person.includesTrash" class="utility-tag">Trash</div>
              <div v-if="person.includesWalkSnowRemoval" class="utility-tag">
                Walk
              </div>
              <div v-if="person.includesWaterSewer" class="utility-tag">
                Water
              </div>
            </template>
            <!-- Show message when no utilities are included -->
            <template v-else>
              <span class="utility-none">( tenant covers all util )</span>
            </template>
          </div>
          <i
            :class="getIconClass(person.mostRecentActivitySource)"
            class="activity-icon"
            @click.stop="
              selectCard($event, person, index);
              togglePanel('showEmailViewer');
            "
          ></i>
        </div>

        <!-- Icons Bar -->
        <div
          v-if="selectedTileIndex !== null && !bulkSMSactive"
          class="icons-bar"
        >
          <div class="icon-item">
            <i class="fas fa-phone" @click="togglePanel('showPhone')"></i>
            <span class="icon-label">Call/Log</span>
          </div>
          <div class="icon-item">
            <i class="fas fa-sms" @click="togglePanel('showSMS')"></i>
            <span class="icon-label">SMS</span>
          </div>
          <div class="icon-item">
            <i
              class="fas fa-envelope"
              @click="togglePanel('showEmailForm')"
            ></i>
            <span class="icon-label">Send</span>
          </div>
          <div class="icon-item">
            <i
              class="fas fa-mail-bulk"
              @click="togglePanel('showEmailViewer')"
            ></i>
            <span class="icon-label">View</span>
          </div>
          <div class="icon-item">
            <i class="fas fa-location" @click="openMap()"></i>
            <span class="icon-label">Map</span>
          </div>
          <div class="icon-item">
            <i class="fas fa-wrench" @click="togglePanel('showWorkOrder')"></i>
            <span class="icon-label">Maint.</span>
          </div>
          <div class="icon-item">
            <i class="fas fa-paw" @click="openPetsDialog()"></i>
            <span class="icon-label">Pets</span>
          </div>
        </div>
      </div>
      <div>
        <!-- Panels -->
        <!-- Email Form -->
        <div v-if="showEmailForm" class="subpanel-form email-viewer">
          <input
            style="width: 99%; font-size: 16px; margin-top: 10px"
            type="text"
            placeholder="Subject"
            v-model="emailSubject"
          />
          <textarea
            placeholder="Body Markdown"
            v-model="emailBody"
            ref="emailBody"
          ></textarea>
          <!-- Rendered Markdown Preview -->
          <div
            class="markdown-preview"
            v-html="renderMarkdown(emailBody)"
          ></div>
          <!-- Buttons -->
          <div class="email-form-buttons">
            <button @click="sendEmail" style="width: 30%">Send</button>
            <button @click="cancelEmail" style="width: 30%">Cancel</button>
          </div>
        </div>

        <!-- Other Panel Templates -->
        <div v-if="showEmailViewer" class="subpanel-form email-viewer">
          <div
            class="email-search-bar"
            style="display: flex; align-items: center"
          >
            <input
              style="font-size: 16px"
              ref="emailFilter"
              v-model="emailFilter"
              placeholder="search"
              @dblclick="this.emailFilter = ''"
            />
            <button
              @click="emailFilter = ''"
              class="clear-search"
              style="height: 32px"
            >
              <i class="fas fa-backspace"></i>
            </button>
          </div>
          <div class="helper-text">
            (tap green outlined name card above to close)
          </div>
          <div class="inner-wrapper">
            <div
              v-for="(email, index) in recentFilteredEmails"
              :key="index"
              @touchstart="handleLongPressStart(email, $event)"
              @mousedown="handleLongPressStart(email, $event)"
              @mouseup="handleLongPressEnd($event)"
              @touchend="handleLongPressEnd($event)"
              @mouseleave="handleLongPressEnd($event)"
              class="email-card"
            >
              <i
                class="fas fa-reply reply-icon"
                @click.stop="handleReply(email)"
              ></i>
              <p><strong>Date:</strong> {{ formatDate(email.sentOn, true) }}</p>
              <p v-if="email.subject && email.subject !== ''">
                <strong>Subject:</strong>
                <span v-html="email.subject"></span>
              </p>
              <p>
                <span v-html="markedCleanBody(email.body)"></span>
              </p>
            </div>
          </div>
        </div>

        <div v-if="showPhone" class="subpanel-form">
          <div @click="dialPhone" class="phone-number">
            Call: {{ selectedPersonPhone }}
          </div>
          <div class="contact-log-title">History</div>
          <div class="contact-log-table">
            <div
              v-for="(log, index) in filteredContactLogs"
              @click="toggleSelectedLog(log)"
              :key="log.timestamp"
              class="contact-log-row"
              :class="{
                'odd-row': index % 2 !== 0,
                'even-row': index % 2 === 0,
              }"
            >
              <div class="contact-log">
                <div class="contact-log-cell timestamp">
                  {{ formatDateTime(log.timestamp) }}
                </div>
                <div class="contact-log-cell type">
                  via {{ log.contactType }}
                </div>
                <div class="contact-log-cell user">
                  by {{ log.displayName }}
                </div>
              </div>
            </div>
          </div>

          <div class="contact-log-message" @click="copyMessageToClipboard">
            {{ selectedLog?.message }}
          </div>
        </div>
        <div v-if="showSMS || bulkSMSactive" class="subpanel-form">
          <div class="phone-number">
            <!-- Display selected person's phone number -->
            Text: {{ selectedPersonPhone || 'list'
            }}<button
              @click="clearText"
              style="margin-left: 20px; width: 40px; height: 28px"
            >
              <i class="fas fa-backspace"></i>
            </button>
          </div>

          <!-- Textarea for entering a message -->
          <textarea
            class="sms-message"
            v-model="smsMessage"
            placeholder="Enter your message here"
            @blur="saveSmsMessage"
          ></textarea>
          <div class="response-footer">
            <div class="button-row">
              <button
                class="response-button"
                :disabled="smsSending"
                @click="sendSMS"
              >
                {{ smsSending ? 'Sending…' : 'Send SMS' }}
              </button>
              <button class="response-button" @click="askPerm">Ask Perm</button>
              <button class="response-button" @click="addPixie">
                Add Pixie
              </button>
              <button class="response-button" @click="addChatBot">
                Add App
              </button>
            </div>
            <div class="button-row">
              <button class="response-button" @click="addLoginHelp">
                Login help
              </button>
              <button class="response-button" @click="addRentNudge">
                Rent Nudge
              </button>
              <button class="response-button" @click="addPayFail">
                Pay Fail
              </button>
              <button class="response-button" @click="needForwarding">
                Fwd Addr
              </button>
            </div>
          </div>

          <!-- Button to trigger sendSms method -->
        </div>

        <div v-if="showNote" class="subpanel-form">
          <p>Note Panel - not yet functional</p>
        </div>

        <div v-if="showWorkOrder" class="work-orders subpanel-form">
          <!-- Loop through maintenance requests -->
          <div
            class="email-search-bar"
            style="display: flex; align-items: center"
          >
            <input
              style="font-size: 16px"
              ref="workOrderFilter"
              v-model="workOrderFilter"
              placeholder="search"
              @dblclick="this.workOrderFilter = ''"
            />
            <button @click="workOrderFilter = ''" class="clear-search">
              <i class="fas fa-backspace"></i>
            </button>
          </div>
          <div class="outer-wrapper">
            <div class="inner-wrapper">
              <div
                v-for="request in filteredWorkOrders"
                :key="request.id"
                class="maint-tile"
                v-html="formattedRequestContent(request)"
              ></div>
            </div>
          </div>
        </div>

        <div v-if="showPayments" class="subpanel-form">
          <p>Payments Panel</p>
        </div>
      </div>
    </div>

    <!-- Pets Edit Dialog -->
    <div
      v-if="showPetsDialog"
      class="pets-dialog-overlay"
      @click.self="closePetsDialog"
    >
      <div class="pets-dialog">
        <div class="pets-dialog-title">Edit Pet Info</div>
        <div class="pets-dialog-subtitle">{{ petDialogPersonName }}</div>
        <div class="pets-dialog-body">
          <div class="pet-info-row">
            <div class="pet-field">
              <label>Dogs:</label>
              <input
                type="number"
                min="0"
                max="9"
                v-model.number="petForm.dogCount"
                class="pet-count-input"
              />
            </div>
            <div class="pet-field">
              <label>Cats:</label>
              <input
                type="number"
                min="0"
                max="9"
                v-model.number="petForm.catCount"
                class="pet-count-input"
              />
            </div>
          </div>
          <div class="pet-info-row">
            <div class="pet-field pet-names-field">
              <label>Names:</label>
              <input
                type="text"
                v-model="petForm.petNames"
                placeholder="e.g. Fido, Fluffy"
                class="pet-names-input"
              />
            </div>
          </div>
          <div class="pet-info-row">
            <label style="font-size: 0.85em; margin-right: 8px"
              >Temperament:</label
            >
            <button
              type="button"
              class="pet-temperament-btn"
              :style="{
                backgroundColor: petTemperamentColor(petForm.dogTemperament),
              }"
              @click="cyclePetFormTemperament('dogTemperament')"
              :title="petTemperamentLabel(petForm.dogTemperament)"
            >
              <i class="fas fa-dog"></i>
            </button>
            <button
              type="button"
              class="pet-temperament-btn"
              :style="{
                backgroundColor: petTemperamentColor(petForm.catTemperament),
              }"
              @click="cyclePetFormTemperament('catTemperament')"
              :title="petTemperamentLabel(petForm.catTemperament)"
            >
              <i class="fas fa-cat"></i>
            </button>
          </div>
        </div>
        <div class="pets-dialog-footer">
          <button @click="savePets">Save</button>
          <button @click="closePetsDialog">Cancel</button>
        </div>
      </div>
    </div>

    <!-- quick Dialog -->
    <div v-if="showDialogPopup" class="small-dialog-overlay">
      <div class="small-dialog-content">
        <div v-html="dialogMessage"></div>
        <div class="small-dialog-buttons">
          <button
            v-for="option in dialogOptions"
            :key="option"
            @click="onDialogOptionSelected(option)"
            :id="option === 'Confirm' ? 'confirmButton' : ''"
          >
            {{ option }}
          </button>
        </div>
      </div>
    </div>

    <TenantBroadcastDialog
      v-if="showTenantBroadcast"
      :people="peopleData"
      @close="showTenantBroadcast = false"
    />
  </div>

  <NewPerson
    v-if="showTenantSearchDialog"
    :initialTenantQuery="this.selectedPerson"
    @closeDialog="handleDialogClosed"
  />

  <NotesPanel
    :showNotesPanel="this.showNotesPanel"
    :noteType="this.noteType"
    :noteId="this.noteId"
    @update-show-notes-panel="updateShowNotesPanel"
  />

  <div class="footer-message">{{ footerMessage }}</div>
</template>

<script>
// TODO: add a 'show done' button
// add a "jump to top" button

import axios from '@/axiosConfig'; // Adjust based on your axios configuration
import eventBus from './eventBus';
import NewPerson from './NewPerson.vue';
import NotesPanel from './NotesPanel.vue';
import TenantBroadcastDialog from './TenantBroadcastDialog.vue';
import { marked } from 'marked';
import MotdModal from './MotdModal.vue'; // Import MOTD Modal component
import {
  tenantSearchSmsPayload,
  tenantSearchSmsTargets,
  tenantSearchSmsSummary,
} from '@/utils/tenantSearchSms';
import {
  personSmsFlagOn,
  personChatNotifyFlagOn,
} from '@/utils/peopleListFilter';
export default {
  components: { NewPerson, NotesPanel, MotdModal, TenantBroadcastDialog },

  created() {
    document.title = 'People Search';
    // Fetch properties and wait for completion
    this.fetchPeople()
      .then(() => {
        // Check for a saved tenant in local storage after properties are fetched
        const savedPerson = localStorage.getItem('selectedPeople');

        if (savedPerson) {
          try {
            this.selectedPeople = JSON.parse(savedPerson);

            const isValid = this.selectedPeople.every((savedPerson) =>
              this.peopleData.some((people) => people.id === savedPerson.id),
            );

            if (!isValid) {
              // console.log('Selected people are not valid.');
              this.selectedPeople = [];
              localStorage.removeItem('selectedPeople');
            }
          } catch (error) {
            console.error(
              'Error parsing selectedPeople from local storage:',
              error,
            );
            // Clear the corrupted or undefined local storage entry
            this.selectedPeople = [];
            localStorage.removeItem('selectedPeople');
          }
        }
        if (this.$route.query.search) {
          this.searchQuery = this.$route.query.search;
        }
      })
      .catch((error) => {
        // Handle errors that occur during fetchPayments
        console.error('Failed to fetch people:', error);
      });
  },

  mounted() {
    // Check localStorage for the active note view count
    const activeNoteViewCount = parseInt(
      localStorage.getItem('activeNoteViewCount') || '0',
    );

    // Only show the note if it hasn't been viewed 3 times yet
    if (activeNoteViewCount < 3) {
      this.showActiveNote = true;
      // Increment the view count and save back to localStorage
      localStorage.setItem(
        'activeNoteViewCount',
        (activeNoteViewCount + 1).toString(),
      );

      // Set a timeout that sets showActiveNote to false after 6 seconds
      setTimeout(() => {
        this.showActiveNote = false;
      }, 6000);
    } else {
      this.showActiveNote = false;
    }

    // Read bulkSMSactive from localStorage and set it accordingly
    const bulkSMSactiveFromStorage = localStorage.getItem('bulkSMSactive');
    this.bulkSMSactive = bulkSMSactiveFromStorage === 'true';
    this.smsMessage = localStorage.getItem('smsMessage') || '';

    // Focus on the search input field
    /*
    this.$nextTick(() => {
      if (this.$refs.searchQuery) {
        this.$refs.searchQuery.focus();
      }
    });
    */

    // Open the IndexedDB database
    const request = indexedDB.open('smsDatabase', 1);

    // Handle errors when opening the database
    request.onerror = (event) => {
      console.error('Database error:', event.target.errorCode);
    };

    // Handle successful database opening
    request.onsuccess = (event) => {
      const db = event.target.result;

      try {
        const transaction = db.transaction(['smsRecipients'], 'readonly');
        const store = transaction.objectStore('smsRecipients');

        // Array to hold retrieved people
        const people = [];

        // Create a cursor to iterate over all entries
        store.openCursor().onsuccess = (event) => {
          const cursor = event.target.result;
          if (cursor) {
            people.push(cursor.value);
            cursor.continue();
          } else {
            // No more entries
            this.bulkSMSlist = people; // Initialize filteredPeople with retrieved data
          }
        };
      } catch (error) {
        if (error.name === 'NotFoundError') {
          this.bulkSMSlist = [];
          this.bulkSMSactive = false;
          localStorage.removeItem('bulkSMSactive');

          // Close the database before deleting
          db.close();

          // Request to delete the smsDatabase
          const deleteRequest = indexedDB.deleteDatabase('smsDatabase');

          deleteRequest.onsuccess = () => {
            console.log('smsDatabase successfully deleted.');
          };

          deleteRequest.onerror = (event) => {
            console.error(
              'Failed to delete smsDatabase:',
              event.target.errorCode,
            );
          };
        } else {
          console.error('Transaction failed:', error);
        }
      }
    };

    // Access the query parameters from the route
    const personId = this.$route.query.personId;

    // Check if personId exists and set the searchQuery
    if (personId) {
      this.searchQuery = `:${personId}`;
    }

    // Add event listener for clicks on document to close panels
    document.addEventListener('click', this.handleDocumentClick);

    // Log user location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          axios.post('/api/log-location', {
            componentName: 'MTenantSearch',
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
          });
        },
        (error) => {
          axios.post('/api/log-location', {
            componentName: 'MTenantSearch',
            locationError: error.message,
          });
        },
      );
    }
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    // Remove document click listener
    document.removeEventListener('click', this.handleDocumentClick);
  },

  data() {
    return {
      db: null,
      workOrders: [],
      onlyCriticalIssues: false,
      contactLogs: [],
      longPressTimeout: null,
      smsMessage: '',
      smsSending: false,
      workOrderFilter: '',
      emailFilter: '',
      recentEmails: [],
      incomingOnly: false,
      includeDeleted: false,
      showEmailForm: false,
      showEmailViewer: false,
      showPhone: false,
      showSMS: false,
      showTenantBroadcast: false,
      showNote: false,
      showWorkOrder: false,
      showPayments: false,
      emailSubject: '',
      emailBody: '',
      selectedTileIndex: null,
      startDate: null,
      showTenantSearchDialog: false,
      endDate: null,
      clickTimeout: null,
      searchQuery: '',
      peopleData: [],
      lastSelectedIndex: null,
      selectedPeople: [],
      selectedPerson: null,

      showPetsDialog: false,
      petForm: {
        leaseId: null,
        dogCount: 0,
        catCount: 0,
        petNames: '',
        dogTemperament: 0,
        catTemperament: 0,
      },
      petDialogPersonName: '',

      peopleTableHeaders: [
        { label: 'First', field: 'First', width: '100px', align: 'left' },
        { label: 'Last', field: 'Last', width: '100px', align: 'left' },
        {
          label: 'fullName',
          field: 'fullName',
          width: '100px',
          align: 'left',
          overflow: true,
        },
        {
          label: 'Email',
          field: 'Email',
          width: '150px',
          align: 'left',
          overflow: true,
        },
        {
          label: 'Phone',
          field: 'Phone',
          width: '100px',
          align: 'center',
          overflow: true,
        },
        {
          label: 'Address',
          field: 'Address',
          width: '150px',
          align: 'left',
          overflow: true,
        },
        { label: 'active', field: 'active', width: '40px', align: 'center' },
        { label: 'tenant', field: 'isTenant', width: '40px', align: 'center' },
        {
          label: 'deactiveOn',
          field: 'deactiveOn',
          width: '70px',
          align: 'center',
        },
        { label: 'Since', field: 'Since', width: '70px', align: 'center' },
        { label: 'note', field: 'noteCount', width: '25px', align: 'center' },
      ],

      sortField: '',
      sortOrder: 'asc',
      showMergeButton: false,
      showDialogPopup: false,
      dialogMessage: '',
      dialogOptions: [],
      dialogCallback: null,
      showSearchPaymentsButton: false,
      showNotesPanel: false,
      noteType: 'tenant',
      noteId: null,
      footerMessage: '',
      // filter buttons
      filterContacted: false,
      filterMaintenance: false,
      filterEmailed: false,
      filterPayment: false,
      // bulk SMS
      bulkSMSactive: false,
      bulkSMSlist: [],
      bulkSMSmessage: '',
      // multi-select mode for building a custom SMS recipient list
      smsSelectMode: false,
      smsSelectionList: [],
      selectedLog: null,
      showActiveNote: true,
      showAll: false,
      isRefreshing: false,
    };
  },

  computed: {
    filteredContactLogs() {
      // Filter the contact logs based on selectedLog condition
      if (!this.selectedLog) {
        return this.contactLogs;
      }
      return this.contactLogs.filter((log) => log.id === this.selectedLog.id);
    },
    containerStyle() {
      return {
        height:
          this.selectedTileIndex === null
            ? this.bulkSMSactive
              ? '28vh'
              : '78vh'
            : '27vh',
        paddingBottom:
          this.selectedTileIndex === null
            ? 'calc(44px + env(safe-area-inset-bottom, 0px))'
            : 'calc(84px + env(safe-area-inset-bottom, 0px))',
      };
    },

    rowCount() {
      // return the length of filteredPeople
      return Array.isArray(this.filteredPeople)
        ? this.filteredPeople.length
        : 0;
    },

    // Compute the sum of the amount field, prioritizing selectedPayments if any
    totalSum() {
      // Check if selectedPayments has any items
      if (this.selectedPeople) {
        const payments =
          this.selectedPeople.length > 0
            ? this.selectedPeople
            : this.filteredPeople;
        if (!Array.isArray(payments)) return '0.00';
        return payments
          .reduce((sum, doc) => {
            // Ensure that doc.amount is a valid number before adding it
            const amount = parseFloat(doc.amount) || 0;
            return sum + amount;
          }, 0)
          .toFixed(2);
      } else return 0.0;
    },

    filteredPeople() {
      // Check if bulkSMSactive is true and return bulkSMSlist if it is
      if (this.bulkSMSactive) {
        return this.bulkSMSlist || [];
      }

      if (!Array.isArray(this.peopleData)) return [];

      // Check if searchQuery is in the format ':number'
      const idMatch = this.searchQuery.match(/^:(\d+)$/);
      if (idMatch) {
        const id = parseInt(idMatch[1], 10);
        return this.peopleData.filter(
          (person) => person.id === id && person.active === 1,
        );
      }

      // Split searchQuery into tokens by comma and trim whitespace
      const tokens = this.searchQuery
        .split(',')
        .map((token) => token.trim().toLowerCase());

      // Select initial data based on showAll variable
      let dataToProcess = this.showAll
        ? this.peopleData
        : this.peopleData.filter((person) => person.active === 1);

      // Separate bracket filters from regular tokens
      const bracketFilters = tokens
        .map((token) => token.replace(/^['"]|['"]$/g, ''))
        .filter((token) => token.match(/^\[.*\]$/));
      const regularTokens = tokens.filter((token) => {
        const normalized = token.replace(/^['"]|['"]$/g, '');
        return !normalized.match(/^\[.*\]$/) && normalized !== ':a';
      });

      const hasBracketSchema = dataToProcess?.some(
        (person) =>
          typeof person.isParentAddr !== 'undefined' &&
          typeof person.parentId !== 'undefined',
      );

      const unitRegex =
        /(\bapt\b|\bapartment\b|\bunit\b|\bsuite\b|\bste\b|\b#\b)/i;

      // Apply additional activitySource filtering
      if (this.filterContacted) {
        dataToProcess = dataToProcess.filter(
          (person) => person.mostRecentActivitySource === 1,
        );
      } else if (this.filterMaintenance) {
        dataToProcess = dataToProcess.filter(
          (person) => person.mostRecentActivitySource === 2,
        );
      } else if (this.filterEmailed) {
        dataToProcess = dataToProcess.filter(
          (person) => person.mostRecentActivitySource === 3,
        );
      } else if (this.filterPayment) {
        dataToProcess = dataToProcess.filter(
          (person) => person.mostRecentActivitySource === 4,
        );
      }

      // Apply bracket filters
      if (bracketFilters.length > 0) {
        bracketFilters.forEach((bracket) => {
          const filterType = bracket.slice(1, -1).toLowerCase(); // Remove brackets and convert to lowercase

          if (filterType === 'single') {
            // Single-family = parent group with exactly one child leaseable property.
            dataToProcess = dataToProcess.filter((person) => {
              const parentChildCount = Number(person.parentChildCount);
              const parentIdNum = Number(person.parentId);

              if (Number.isFinite(parentChildCount) && parentChildCount > 0) {
                return parentChildCount === 1;
              }

              if (hasBracketSchema && Number.isFinite(parentIdNum)) {
                return parentIdNum <= 0;
              }

              const addressText = `${person.Address || ''} ${person.LongAddress || ''}`;
              return !unitRegex.test(addressText);
            });
          } else if (filterType === 'multi') {
            // Multi-family = parent group with more than one child leaseable property.
            dataToProcess = dataToProcess.filter((person) => {
              const parentChildCount = Number(person.parentChildCount);
              const parentIdNum = Number(person.parentId);
              if (Number.isFinite(parentChildCount) && parentChildCount > 0) {
                return parentChildCount > 1;
              }

              if (hasBracketSchema && Number.isFinite(parentIdNum)) {
                return parentIdNum > 0;
              }

              const addressText = `${person.Address || ''} ${person.LongAddress || ''}`;
              return unitRegex.test(addressText);
            });
          }
        });
      }

      // If there are regular tokens, apply filtering with each
      if (regularTokens.length > 0) {
        dataToProcess = dataToProcess.filter((person) => {
          // Convert values to lowercase strings for comparison
          const personValues = Object.values(person).map((value) =>
            value ? value.toString().toLowerCase() : '',
          );

          // Check if every remaining token is included in any property value
          return regularTokens.every((token) =>
            personValues.some((value) => value.includes(token)),
          );
        });
      }

      // Return data based on default conditions
      return dataToProcess;
    },

    recentFilteredEmails() {
      const term = this.emailFilter.toLowerCase();
      const tokens = term.split(',').map((token) => token.trim().toLowerCase());

      let filteredEmails = this.recentEmails;

      if (this.incomingOnly) {
        // Exclude emails where 'from' starts with "communications@"
        filteredEmails = filteredEmails.filter(
          (email) => email.from && !email.from.startsWith('communications@'),
        );
      }

      // Filter emails based on tokens
      if (tokens.length > 0 && tokens[0] !== '') {
        // Apply filtering sequentially based on each token
        tokens.forEach((token) => {
          filteredEmails = filteredEmails.filter((email) => {
            // Convert values to lowercase strings for comparison
            const emailValues = Object.values(email).map((value) =>
              value ? value.toString().toLowerCase() : '',
            );
            // Check if the current token is included in any property value
            return emailValues.some((value) => value.includes(token));
          });
        });
      }
      // Iterate over filteredEmails and highlight matches
      return filteredEmails.map((email) => {
        const highlightedEmail = {};

        for (const [key, value] of Object.entries(email)) {
          if (key !== 'id') {
            // Exclude 'id' from being highlighted
            highlightedEmail[key] = value
              ? this.highlightMatch(this.emailFilter, value)
              : value;
          } else {
            highlightedEmail[key] = value; // Simply copy 'id' without modification
          }
        }

        return highlightedEmail;
      });
    },

    filteredWorkOrders() {
      const term = this.workOrderFilter.toLowerCase();
      const tokens = term.split(',').map((token) => token.trim().toLowerCase());

      let filteredWorkOrders = this.workOrders;

      // Example specific filtering condition, adjust according to needs
      if (this.onlyCriticalIssues) {
        filteredWorkOrders = filteredWorkOrders.filter(
          (request) => request.isCritical, // assumes there is an 'isCritical' property
        );
      }

      // Filter work orders based on tokens
      if (tokens.length > 0 && tokens[0] !== '') {
        // Apply filtering sequentially based on each token
        tokens.forEach((token) => {
          filteredWorkOrders = filteredWorkOrders.filter((request) => {
            // Convert values to lowercase strings for comparison
            const requestValues = Object.values(request).map((value) =>
              value ? value.toString().toLowerCase() : '',
            );

            // Check if the current token is included in any property value
            return requestValues.some((value) => value.includes(token));
          });
        });
      }

      // Iterate over filteredWorkOrders and highlight matches
      return filteredWorkOrders.map((request) => {
        const highlightedRequest = {};

        for (const [key, value] of Object.entries(request)) {
          if (!['id', 'peopleId', 'propertyId', 'allow_entry'].includes(key)) {
            // Exclude 'id', 'peopleId', and 'propertyId' from being highlighted
            highlightedRequest[key] = value
              ? this.highlightMatch(this.workOrderFilter, value)
              : value;
          } else {
            highlightedRequest[key] = value; // Simply copy without modification
          }
        }

        return highlightedRequest;
      });
    },

    selectedPersonPhone() {
      return (
        this.filteredPeople[this.selectedTileIndex]?.Phone ||
        'to the list above'
      );
    },

    smsSelectionCount() {
      return Array.isArray(this.smsSelectionList)
        ? this.smsSelectionList.length
        : 0;
    },

    smsButtonTitle() {
      if (this.bulkSMSactive) {
        return 'Cancel bulk SMS';
      }
      if (this.smsSelectMode) {
        return this.smsSelectionCount
          ? `Send SMS to ${this.smsSelectionCount} selected`
          : 'Tap cards to select, then tap again to SMS';
      }
      return 'Select tenants for bulk SMS';
    },
  },

  methods: {
    isMobile() {
      return window.innerWidth <= 768; // Adjust the width threshold as needed
    },

    personSmsKey(person) {
      if (!person) return null;
      if (person.id != null) return `id:${person.id}`;
      if (person.Phone) return `phone:${person.Phone}`;
      return null;
    },

    isSmsSelected(person) {
      if (!this.smsSelectMode && !this.bulkSMSactive) return false;
      const key = this.personSmsKey(person);
      if (!key) return false;
      return this.smsSelectionList.some((p) => this.personSmsKey(p) === key);
    },

    toggleSmsSelection(person) {
      const key = this.personSmsKey(person);
      if (!key) return;
      const idx = this.smsSelectionList.findIndex(
        (p) => this.personSmsKey(p) === key,
      );
      if (idx >= 0) {
        this.smsSelectionList.splice(idx, 1);
      } else {
        this.smsSelectionList.push(person);
      }
    },

    clearSmsSelectionMode() {
      this.smsSelectMode = false;
      this.smsSelectionList = [];
    },

    serializablePerson(person) {
      return {
        id: person.id,
        First: person.First,
        Last: person.Last,
        fullName: person.fullName,
        Email: person.Email,
        Phone: person.Phone,
        Address: person.Address,
        leaseId: person.leaseId,
        active: person.active,
        deactivatedOn: person.deactivatedOn,
        activeFrom: person.activeFrom,
        isTenant: person.isTenant,
        forwardingNote: person.forwardingNote,
        flags: person.flags,
        noteCount: person.noteCount,
        mostRecentActivitySource: person.mostRecentActivitySource,
      };
    },

    startBulkSmsFromList(people) {
      const list = (people || []).filter((p) => p && p.Phone);
      if (!list.length) {
        this.updateFooterMessage(
          'No selected tenants with phone numbers to SMS.',
        );
        return;
      }

      this.bulkSMSlist = list.slice();
      this.bulkSMSactive = true;
      this.smsSelectMode = false;
      this.selectedTileIndex = null;
      this.togglePanel('all');
      localStorage.setItem('bulkSMSactive', 'true');

      const request = indexedDB.open('smsDatabase', 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('smsRecipients')) {
          db.createObjectStore('smsRecipients', {
            keyPath: 'id',
            autoIncrement: true,
          });
        }
      };

      request.onerror = (event) => {
        console.error('Database error:', event.target.errorCode);
      };

      request.onsuccess = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains('smsRecipients')) {
          console.error('Failed to find the required object store.');
          return;
        }

        const transaction = db.transaction(['smsRecipients'], 'readwrite');
        const store = transaction.objectStore('smsRecipients');

        store.clear().onsuccess = () => {
          list.forEach((person) => {
            store.add(this.serializablePerson(person));
          });
        };
      };

      const storedSmsMessage = localStorage.getItem('smsMessage');
      if (storedSmsMessage) {
        this.smsMessage = storedSmsMessage;
      }
    },
    toggleSelectedLog(log) {
      // Toggle selectedLog based on current state
      this.selectedLog =
        this.selectedLog && this.selectedLog.id === log.id ? null : log;
    },
    async copyMessageToClipboard() {
      if (!this.selectedLog?.message) {
        return;
      }

      // Check if clipboard API is available
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(this.selectedLog.message);
          alert('Message copied to clipboard');
        } catch (err) {
          // Silently fail if clipboard write fails
          console.error('Failed to copy to clipboard:', err);
        }
      }
      // If clipboard API is not available, do nothing
    },
    filterBy(condition) {
      this.selectedTileIndex = null;
      // Map conditions to their respective filter properties
      const filters = {
        contacted: 'filterContacted',
        maintenance: 'filterMaintenance',
        emailed: 'filterEmailed',
        payment: 'filterPayment',
      };

      if (filters[condition]) {
        // Toggle the selected filter
        this[filters[condition]] = !this[filters[condition]];

        // Clear all other filters
        Object.keys(filters).forEach((key) => {
          if (key !== condition) {
            this[filters[key]] = false;
          }
        });
      } else {
        // Handle unexpected conditions
        console.warn('Unexpected filter condition:', condition);
      }
    },

    getIconClass(activitySource) {
      switch (activitySource) {
        case 1:
          return 'fas fa-sign-out';
        case 2:
          return 'fas fa-wrench';
        case 3:
          return 'fas fa-envelope';
        case 4:
          return 'fas fa-money-check-dollar';
        default:
          return ''; // Return an empty string or a default class if needed
      }
    },

    personSmsOn(person) {
      return personSmsFlagOn(person);
    },

    personNotifyOn(person) {
      return personChatNotifyFlagOn(person);
    },

    formatTimeAgo(timestamp) {
      const now = new Date();
      const activityDate = new Date(timestamp);
      const diffInSeconds = Math.floor((now - activityDate) / 1000);

      const intervals = [
        { label: 'year', seconds: 31536000 },
        { label: 'month', seconds: 2592000 },
        { label: 'day', seconds: 86400 },
        { label: 'hr', seconds: 3600 },
        { label: 'min', seconds: 60 },
      ];

      for (const interval of intervals) {
        const count = Math.floor(diffInSeconds / interval.seconds);
        if (count >= 1) {
          return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`;
        }
      }

      return 'just now';
    },

    vibrate(pattern) {
      // Check if the browser supports the Vibration API
      if ('vibrate' in navigator) {
        // Use the Vibrate API with a pattern (array of durations)
        navigator.vibrate(pattern);
      } else {
        console.warn('Vibration API not supported by this browser.');
      }
    },

    togglePanel(panelName) {
      this.vibrate(200);

      const panels = [
        'showEmailForm',
        'showEmailViewer',
        'showPhone',
        'showSMS',
        'showNote',
        'showWorkOrder',
        'showPayments',
      ];

      // If panelName is "all", close all panels
      if (panelName === 'all') {
        panels.forEach((panel) => {
          this[panel] = false;
        });
      } else {
        // Toggle the specified panel and close others
        panels.forEach((panel) => {
          this[panel] = panel === panelName ? !this[panel] : false;
        });
      }
    },

    toggleEmailForm() {
      this.showEmailForm = !this.showEmailForm;
    },

    toggleEmailInbox() {
      // Only toggle if a tile is selected
      if (
        this.selectedTileIndex === null ||
        this.selectedTileIndex === undefined
      ) {
        this.updateFooterMessage('Please select a contact first');
        return;
      }

      this.showEmailViewer = !this.showEmailViewer;
      if (this.showEmailViewer) {
        // console.log('Fetching');
        this.fetchRecentCommunications();
      }
    },

    cancelEmail() {
      this.showEmailForm = false;
      this.emailSubject = '';
      this.emailBody = '';
    },

    async sendEmail() {
      const person = this.filteredPeople[this.selectedTileIndex] || {};
      const recipients = String(person.SendEmail || person.sendEmail || '').trim();
      if (!recipients || recipients.toLowerCase().endsWith('@noemail.com')) {
        this.updateFooterMessage('No active email for this contact.');
        return;
      }
      try {
        const response = await axios.post('/api/send-email', {
          from: 'communications@bigpropertymanagement.com',
          subject: this.emailSubject,
          body: this.renderMarkdown(this.emailBody),
          recipients: recipients,
        });

        if (response.status === 200) {
          this.updateFooterMessage('Email sent successfully!');
          this.logContact(1);
          this.cancelEmail();
        }
      } catch (error) {
        console.error('Error sending email:', error);
        alert('Failed to send email.');
      }
    },

    renderMarkdown(markdownText) {
      // Use a markdown library like marked.js to convert markdown text to HTML
      return marked(markdownText);
    },

    selectCard(event, person, index) {
      // In SMS select mode, taps add/remove from the bulk SMS list
      if (this.smsSelectMode && !this.bulkSMSactive) {
        this.toggleSmsSelection(person);
        return;
      }

      // Normal mode: toggle the active card
      this.selectedTileIndex = this.selectedTileIndex === index ? null : index;
      this.togglePanel('all');
      this.emailFilter = '';
      this.selectedLog = null;
    },

    clearSelection() {
      this.selectedTileIndex = null;
    },

    updateShowNotesPanel(newVal) {
      this.showNotesPanel = newVal;
      if (!newVal) {
        this.fetchPeople();
      }
    },

    openNotesPanel(id) {
      this.noteId = id;
      this.showNotesPanel = true;
    },

    setDates() {
      const today = new Date();
      const endDate = new Date(today);
      endDate.setDate(today.getDate() - 30);

      this.endDate = today.toISOString().split('T')[0]; // Convert to YYYY-MM-DD
      this.startDate = endDate.toISOString().split('T')[0]; // Convert to YYYY-MM-DD
    },

    debounce(func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout); // Clear the previous timeout
        timeout = setTimeout(() => {
          func.apply(this, args); // Apply the function after the delay
        }, delay);
      }.bind(this);
    },

    async initDB() {
      // console.log('initDB');
      return new Promise((resolve, reject) => {
        const request = indexedDB.open('peopleDatabase', 1);

        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains('people')) {
            // Create an object store with 'row_num' as the key path
            db.createObjectStore('people', {
              keyPath: 'row_num',
              autoIncrement: false, // Not needed since we are using row_num directly
            });
          }
        };

        request.onsuccess = (event) => {
          this.db = event.target.result;
          resolve(this.db);
        };

        request.onerror = (event) => {
          console.error('IndexedDB error:', event.target.errorCode);
          reject(event.target.errorCode);
        };
      });
    },

    async fetchAndSortData(objectStore) {
      try {
        // Retrieve all data from the object store
        const storedData = await new Promise((resolve, reject) => {
          const request = objectStore.getAll();
          request.onsuccess = () => resolve(request.result || []);
          request.onerror = () => reject(request.error);
        });

        // Sort the fetched data by row_num in ascending order
        storedData.sort((a, b) => a.row_num - b.row_num);

        return storedData;
      } catch (error) {
        console.error('Error fetching data from objectStore:', error);
        throw new Error('Failed to retrieve and sort data');
      }
    },

    async fetchPeople(forceReset = false) {
      this.isRefreshing = true;
      await this.$nextTick();
      if (!this.db) {
        await this.initDB();
      }

      const transaction = this.db.transaction(['people'], 'readonly');
      const objectStore = transaction.objectStore('people');

      try {
        // Retrieve existing data in case needed later
        const storedData = await this.fetchAndSortData(objectStore);
        // console.log('Stored Data Count before API call:', storedData.length);

        const isBracketSchemaMissing =
          storedData.length > 0 &&
          (typeof storedData[0].isParentAddr === 'undefined' ||
            typeof storedData[0].parentId === 'undefined' ||
            typeof storedData[0].parentChildCount === 'undefined' ||
            typeof storedData[0].currentLeaseBalance === 'undefined' ||
            typeof storedData[0].smsOptIn === 'undefined' ||
            typeof storedData[0].pixieNotifications === 'undefined');

        let latestId, mostRecentActivity;

        if (forceReset || isBracketSchemaMissing) {
          latestId = 0;
          mostRecentActivity = '1970-01-01T00:00:00Z';
        } else {
          latestId = storedData[0]?.id || 0;
          mostRecentActivity =
            storedData[0]?.mostRecentActivity || '1970-01-01T00:00:00Z';
        }

        // Make the API call
        const response = await axios.get('/api/all-people', {
          params: { id: latestId, mostRecentActivity },
        });

        const fetchedData = response.data.map((person, index) => ({
          ...person,
          extraProperty: 0,
          row_num: index + 1,
        }));

        // Insert test person "Eric Tilton" with specified properties
        const testPerson = {
          row_num: 0, // Ensure unique row number if it's an identifier
          id: 0, // Unique ID for Eric Tilton
          First: 'Eric',
          Last: 'Tilton',
          fullName: 'Eric Tilton',
          Email: 'eric@bigpropertymanagement.com',
          Phone: '559-321-3062',
          Address: '315 Richard Terrace',
          leaseId: 0,
          active: 1,
          deactivatedOn: null,
          activeFrom: null,
          isTenant: 1,
          forwardingNote: null,
          flags: null,
          noteCount: 0,
          mostRecentActivitySource: 1,
        };

        // console.log('Fetched Data Count:', fetchedData.length);

        if (fetchedData.length > 0) {
          // Clear and update IndexedDB with new data from the API
          const updateTransaction = this.db.transaction(
            ['people'],
            'readwrite',
          );
          const updateObjectStore = updateTransaction.objectStore('people');

          // Clear all current entries in the object store first
          await new Promise((resolve, reject) => {
            const clearRequest = updateObjectStore.clear();
            clearRequest.onsuccess = () => {
              // console.log('Successfully cleared existing data.');
              resolve();
            };
            clearRequest.onerror = () => {
              console.error('Error clearing the store:', clearRequest.error);
              reject(new Error('Failed to clear IndexedDB'));
            };
          });

          // Populate the object store with new data from API
          await Promise.all(
            fetchedData.map(
              (person) =>
                new Promise((resolve, reject) => {
                  const addRequest = updateObjectStore.add(person);
                  addRequest.onsuccess = resolve;
                  addRequest.onerror = () => {
                    console.error('Error adding a person:', addRequest.error);
                    reject(new Error('Failed to add item to IndexedDB'));
                  };
                }),
            ),
          );

          // Update this.peopleData with new data
          this.peopleData = fetchedData;
          this.peopleData.push(testPerson);

          const countRequest = updateObjectStore.count();
          countRequest.onsuccess = () => {
            // console.log('Updated Stored Data Count:', countRequest.result);
          };
        } else {
          // API returned no data, so use locally stored data
          this.peopleData = storedData;
          this.peopleData.push(testPerson);
          // console.log('No new data from API. Loaded local data.');
        }
      } catch (error) {
        console.error('Error fetching people:', error);
      } finally {
        this.isRefreshing = false;
      }
    },

    formatDate(dateString) {
      const options = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC',
      };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },

    petTemperamentColor(value) {
      const colors = ['#aaa', '#4caf50', '#ffc107', '#f44336'];
      return colors[value] || colors[0];
    },

    petTemperamentLabel(value) {
      const labels = ['N/A', 'Friendly', 'Caution', 'Unfriendly'];
      return labels[value] || labels[0];
    },

    cyclePetFormTemperament(field) {
      this.petForm[field] = ((this.petForm[field] || 0) + 1) % 4;
    },

    openPetsDialog() {
      if (
        this.selectedTileIndex === null ||
        this.selectedTileIndex === undefined
      ) {
        this.updateFooterMessage('Please select a contact first');
        return;
      }

      const person = this.filteredPeople[this.selectedTileIndex];
      if (!person || !person.leaseId) {
        this.updateFooterMessage('No active lease found for this person');
        return;
      }

      this.petDialogPersonName = `${person.First} ${person.Last} — ${person.Address}`;
      this.petForm = {
        leaseId: person.leaseId,
        dogCount: person.dogCount || 0,
        catCount: person.catCount || 0,
        petNames: person.petNames || '',
        dogTemperament: person.dogTemperament || 0,
        catTemperament: person.catTemperament || 0,
      };
      this.showPetsDialog = true;
    },

    closePetsDialog() {
      this.showPetsDialog = false;
    },

    async savePets() {
      try {
        await axios.post('/api/update-lease-pets', {
          id: this.petForm.leaseId,
          dogCount: this.petForm.dogCount,
          catCount: this.petForm.catCount,
          petNames: this.petForm.petNames,
          dogTemperament: this.petForm.dogTemperament,
          catTemperament: this.petForm.catTemperament,
        });

        // Update the local person data so tiles reflect the change
        const person = this.filteredPeople[this.selectedTileIndex];
        if (person) {
          person.dogCount = this.petForm.dogCount;
          person.catCount = this.petForm.catCount;
          person.petNames = this.petForm.petNames;
          person.dogTemperament = this.petForm.dogTemperament;
          person.catTemperament = this.petForm.catTemperament;
          person.petCount =
            (this.petForm.dogCount || 0) + (this.petForm.catCount || 0);
        }

        this.updateFooterMessage('Pet info saved');
        this.showPetsDialog = false;
      } catch (error) {
        console.error('Error saving pet info:', error);
        this.updateFooterMessage('Error saving pet info');
      }
    },

    formatNumber(value, digits) {
      if (typeof value !== 'number') value = parseFloat(value);
      if (isNaN(value)) return '';
      if (value === 0.0) return '0.00';
      const sign = value < 0 ? '- ' : '';
      return `${sign}${Math.abs(value).toLocaleString('en-US', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      })}`;
    },

    handleSearchFocus() {
      if (this.searchQuery) {
        this.clearSearch();
        this.showDialogPopup = false;
      }
    },

    clearSearch() {
      this.filterContacted =
        this.filterEmailed =
        this.filterMaintenance =
        this.filterPayment =
        this.bulkSMSactive =
        this.showAll =
          false;
      this.searchQuery = '';
      this.bulkSMSlist = [];
      this.clearSmsSelectionMode();
      this.togglePanel('all');
      this.selectedTileIndex = null;
    },

    getBalance() {
      // Iterate over each property in propertyData and append a balance of 0
      this.peopleData = this.peopleData.map((person) => ({
        ...person,
        balance: 0, // Placeholder value for balance
      }));
    },

    sortBy(field) {
      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortOrder = 'asc';
      }
      this.sortValues();
    },

    sortValues() {
      this.peopleData.sort((a, b) => {
        const sortMultiplier = this.sortOrder === 'asc' ? 1 : -1;
        const field = this.sortField;

        let aValue = a[field];
        let bValue = b[field];

        // Check if the values are dates in "mm/dd/yy" format
        if (typeof aValue === 'string' && typeof bValue === 'string') {
          const dateRegex = /^\d{2}\/\d{2}\/\d{2}$/;
          if (dateRegex.test(aValue) && dateRegex.test(bValue)) {
            // Parse as dates
            aValue = new Date(aValue);
            bValue = new Date(bValue);
          } else if (!isNaN(aValue) && !isNaN(bValue)) {
            // Parse as numbers
            aValue = parseFloat(aValue);
            bValue = parseFloat(bValue);
          }
        }

        if (aValue > bValue) return 1 * sortMultiplier;
        if (aValue < bValue) return -1 * sortMultiplier;
        return 0;
      });
    },

    onDateChange() {
      // Check if both startDate and endDate are valid dates
      const startDate = new Date(this.startDate);
      const endDate = new Date(this.endDate);

      if (
        !this.startDate ||
        !this.endDate ||
        isNaN(startDate.getTime()) ||
        isNaN(endDate.getTime())
      ) {
        return; // Exit the function if either date is invalid
      }

      // Check if startDate is earlier than endDate
      if (startDate >= endDate) {
        return; // Exit the function if startDate is not earlier than endDate
      }

      // If validation passes, fetch payments
      this.fetchPeople();
    },

    handleKeyDown(event) {
      // If the Escape key is pressed
      if (event.key === 'Escape') {
        if (this.selectedPeople.length === 0) {
          // If there are no selected payments, clear the search query
          this.searchQuery = '';
          if (this.$refs.searchQuery) this.$refs.searchQuery.focus();
        } else {
          // Otherwise, clear the selected payments
          this.selectedPeople = [];
          // Delete the local storage item 'selectedPeople'
          localStorage.removeItem('selectedPeople');
        }
      }
    },

    navigateToLeaseSearch(address) {
      // Navigate to LeaseSearch page with query parameter
      // this.$router.push({ path: '/lease-search', query: { search: searchValue.address } });
      // Open LeaseSearch page in a new tab with the query parameter
      const url = this.$router.resolve({
        path: '/lease-search',
        query: { search: address },
      }).href;

      window.open(url, '_blank'); // Open the URL in a new tab
    },

    handleDialogClosed() {
      this.showTenantSearchDialog = false;
      this.fetchPeople();
    },

    mergePeople() {
      // Check if there are exactly two selected people
      if (this.selectedPeople.length !== 2) {
        return; // If not, exit early
      }

      // one of the two selected people must be 'Unknown' in person.First
      if (
        !this.selectedPeople.some(
          (person) => person.First === 'Unknown' || person.Last === 'Unknown',
        )
      ) {
        this.showDialog(
          'One person must have Unknown in First and Last name fields.',
          ['OK'],
        ).then((option) => {
          if (option === 'OK') {
            return;
          }
        });
      } else {
        // Get the two selected IDs based on their names (known or unknown)
        const fromId = this.selectedPeople.find(
          (person) => person.First === 'Unknown',
        ).id;
        const toId = this.selectedPeople.find(
          (person) => person.First !== 'Unknown',
        ).id;
        const knownPerson = this.selectedPeople.find(
          (person) => person.First !== 'Unknown',
        ); // Get the full object for the known person

        // Check if the known person has an assigned leaseId
        if (!knownPerson.leaseId) {
          this.showDialog(
            'The known person in the merge must have an assigned lease first.',
            ['OK'],
          );
          return; // Stop further processing if there is no leaseId
        }

        // Show confirmation dialog before proceeding
        this.showDialog(
          'Do you want to merge these two rows and move payments from the "Unknown" person to the known person?',
          ['Cancel', 'Confirm'],
        ).then((option) => {
          if (option === 'Confirm') {
            // Proceed with the merge if confirmed
            axios
              .post('/api/merge-people', { fromId, toId })
              .then(() => {
                this.fetchPeople(); // Refresh the people data after the merge
                this.selectedPeople = []; // Clear the selected people
                localStorage.setItem(
                  'selectedPeople',
                  JSON.stringify(this.selectedPeople),
                ); // Update local storage
              })
              .catch((error) => {
                console.error('Error merging people:', error);
              });
          } else {
            console.log('Merge cancelled');
          }
        });
      }
    },

    async logContact(type, person = null, message = null) {
      // Determine the personId based on whether the person parameter was supplied
      const personId = person
        ? person.id
        : this.filteredPeople[this.selectedTileIndex].id;

      try {
        // Send a POST request with type and personId
        await axios.post('/api/log-contact', {
          type: type,
          person: personId,
          message,
        });
      } catch (error) {
        console.error(error);
      }
    },

    showDialog(message, options) {
      this.dialogMessage = message;
      this.dialogOptions = options;
      this.showDialogPopup = true;

      return new Promise((resolve) => {
        this.dialogCallback = resolve;
      });
    },

    onDialogOptionSelected(option) {
      this.showDialogPopup = false;
      if (this.dialogCallback) {
        this.dialogCallback(option);
        this.dialogCallback = null; // Clear the callback
      }
    },

    searchPayments() {
      const fullName = this.selectedPeople[0].fullName;

      // Navigate to the /payments route with the fullName as a search query
      this.$router.push({
        path: '/payments',
        query: { search: fullName },
      });
    },

    async fetchRecentCommunications() {
      // Check if a tile is selected before trying to access the Email property
      if (
        this.selectedTileIndex === null ||
        this.selectedTileIndex === undefined ||
        !this.filteredPeople.length
      ) {
        console.warn('No person selected when trying to fetch communications');
        return;
      }

      // Check if quickEmailTo is an object and it's not empty.
      // const emails = this.quickEmailTo.split(',').map((email) => email.trim());
      const emails = String(
        this.filteredPeople[this.selectedTileIndex].Email || '',
      )
        .split(/[;,]/)
        .map((email) => email.trim())
        .filter(Boolean);
      const includeDeleted = this.includeDeleted;

      try {
        // Send a POST request with emails and includeDeleted flag
        const response = await axios.post('/api/recent-emails', {
          emails,
          includeDeleted, // Include the optional parameter in the request payload
        });

        // Update recentEmails with the data received from the server
        this.recentEmails = response.data;
      } catch (error) {
        // Log any errors that occur during the request
        console.error('Error fetching recent emails:', error);
      }
    },

    highlightMatch(filter, content) {
      if (!filter) return content;

      const query = filter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${query})`, 'gi');
      return content.replace(regex, '<mark>$1</mark>');
    },

    markedCleanBody(body) {
      const sanitizedBody = body.replace(
        /[^a-zA-Z0-9.,?!;:'"(){}[\]<>%@#$&*\-=_+~`|\\/\s]/g,
        '',
      );
      return marked.parse(sanitizedBody);
    },

    dialPhone() {
      // Assuming selectedPersonPhone holds the phone number
      const personPhone = this.selectedPersonPhone || '';

      if (personPhone) {
        // Open a link to tel:// using window.location to invoke phone app
        this.logContact(2);
        window.location.href = `tel:${personPhone}`;
        // todo: add an api call to log who called the tenant and when
      } else {
        console.error('No phone number selected.');
      }
    },

    openTenantBroadcast() {
      this.showTenantBroadcast = true;
    },
    async sendSMS() {
      if (this.smsSending) return;

      if (this.bulkSMSactive && !this.bulkSMSlist.length) {
        try {
          this.bulkSMSlist = await this.loadSmsRecipientsFromDb();
        } catch (error) {
          console.error('No recipients in IndexDB.', error);
        }
      }

      const people = tenantSearchSmsTargets({
        bulkActive: this.bulkSMSactive,
        bulkList: this.bulkSMSlist,
        selectedPerson:
          this.selectedTileIndex == null
            ? null
            : this.filteredPeople[this.selectedTileIndex],
      });
      const plans = people.map((person) => ({
        person,
        ...tenantSearchSmsPayload(person, this.smsMessage),
      }));

      if (!plans.some((plan) => plan.ok)) {
        this.updateFooterMessage(tenantSearchSmsSummary(plans));
        return;
      }

      localStorage.setItem('smsMessage', this.smsMessage);
      this.smsSending = true;
      const results = [];
      const accepted = [];
      try {
        for (const plan of plans) {
          if (!plan.ok) {
            results.push(plan);
            continue;
          }
          try {
            const { data } = await axios.post('/api/sms/send', plan.payload);
            results.push({
              ok: true,
              name: plan.name,
              status: data && data.message && data.message.status,
            });
            accepted.push(plan.person);
            this.logContact(3, plan.person, plan.payload.body);
          } catch (err) {
            const data = err.response && err.response.data;
            results.push({
              ok: false,
              name: plan.name,
              reason: (data && (data.reason || data.error)) || 'failed',
            });
          }
        }
      } finally {
        this.smsSending = false;
      }

      this.updateFooterMessage(tenantSearchSmsSummary(results));

      if (this.bulkSMSactive && accepted.length) {
        for (const person of accepted) {
          try {
            await this.removePersonFromIndexDB(person);
          } catch (error) {
            console.error('Could not remove SMS recipient', error);
          }
        }
        const acceptedKeys = new Set(
          accepted.map((person) => this.personSmsKey(person)),
        );
        this.bulkSMSlist = this.bulkSMSlist.filter(
          (person) => !acceptedKeys.has(this.personSmsKey(person)),
        );
        if (this.bulkSMSlist.length === 0) {
          this.bulkSMSactive = false;
          this.selectedTileIndex = null;
          this.clearSmsSelectionMode();
          localStorage.setItem('bulkSMSactive', 'false');
        } else {
          this.smsSelectionList = this.bulkSMSlist.slice();
        }
      }
    },

    loadSmsRecipientsFromDb() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open('smsDatabase', 1);
        request.onerror = () => {
          reject(new Error('Failed to open database'));
        };
        request.onsuccess = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains('smsRecipients')) {
            resolve([]);
            return;
          }
          const transaction = db.transaction(['smsRecipients'], 'readonly');
          const objectStore = transaction.objectStore('smsRecipients');
          const people = [];
          const cursorRequest = objectStore.openCursor();
          cursorRequest.onerror = () => {
            reject(new Error('Failed to retrieve data from object store'));
          };
          cursorRequest.onsuccess = (cursorEvent) => {
            const cursor = cursorEvent.target.result;
            if (cursor) {
              people.push(cursor.value);
              cursor.continue();
            } else {
              resolve(people);
            }
          };
        };
      });
    },

    async removePersonFromIndexDB(person) {
      return new Promise((resolve, reject) => {
        // Open a connection to the database
        const request = indexedDB.open('smsDatabase', 1);

        request.onerror = (event) => {
          console.error('Database error:', event.target.errorCode);
          reject(new Error('Failed to open database'));
        };

        request.onsuccess = (event) => {
          const db = event.target.result;
          const transaction = db.transaction(['smsRecipients'], 'readwrite');
          const objectStore = transaction.objectStore('smsRecipients');

          // Assuming `person` object has an ID or key property for identification
          const deleteRequest = objectStore.delete(person.id);

          deleteRequest.onerror = (event) => {
            console.error('Error while deleting:', event.target.errorCode);
            reject(new Error('Could not remove the person from the database'));
          };

          deleteRequest.onsuccess = () => {
            resolve(true); // Resolve when deletion is successful
          };
        };
      });
    },

    updateFooterMessage(message) {
      eventBus.emit('footerMessage', message);
    },

    handleLongPressStart(email, event) {
      this.longPressTimeout = setTimeout(() => {
        this.handleLongPress(email, event);
      }, 1000); // 500ms threshold for long press
    },

    handleLongPressEnd() {
      clearTimeout(this.longPressTimeout);
    },

    handleLongPress(email) {
      // Long press logic
      console.log('Long press detected:', email);
      this.handleDoubleClick(email); // Reuse double-click logic if needed
    },

    handleDoubleClick(email) {
      const fullName = this.filteredPeople[this.selectedTileIndex].fullName;
      this.emailBody =
        `${fullName} said:<br>` + this.markedCleanBody(email.body);
      this.showEmailViewer = false;
      this.showEmailForm = true;

      this.$nextTick(() => {
        const textarea = this.$refs.emailBodyTextarea;
        if (textarea) {
          textarea.focus();
          textarea.setSelectionRange(0, 0);
        }
      });
    },

    handleReply(email) {
      this.filteredPeople[this.selectedTileIndex].fullName;
      this.emailBody =
        '\n\n' + '----------------\n' + this.markedCleanBody(email.body);
      this.emailSubject = email.subject ? `Re: ${email.subject}` : '';
      this.togglePanel('showEmailForm');

      this.$nextTick(() => {
        const textarea = this.$refs.emailBody;
        if (textarea) {
          textarea.focus();
          textarea.setSelectionRange(0, 0);
          textarea.scrollTop = 0; // Scroll to top
        }
      });
    },

    fetchContactLogs(personId) {
      axios
        .get('/api/log-contact', { params: { personId } })
        .then((response) => {
          this.contactLogs = response.data;
        })
        .catch((error) => {
          console.error('Error fetching contact logs:', error);
        });
    },

    fetchWorkOrders(personId) {
      axios
        .get('/api/maintenance-requests', { params: { personId } })
        .then((response) => {
          this.workOrders = response.data;
        })
        .catch((error) => {
          console.error('Error fetching maintenance requests:', error);
        });
    },

    formatDateTime(timestamp) {
      const options = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      };

      return new Intl.DateTimeFormat('en-US', options).format(
        new Date(timestamp),
      );
    },

    formattedRequestContent(request) {
      const dateTime = request.sent_datetime
        ? this.formatDateTime(request.sent_datetime)
        : this.formatDate(request.date);
      const content = `**Date:** ${dateTime} <br> **Property Address:**<br> ${request.property_address}<br> **Problem Description:**<br> ${request.problem_description}<br><br>**Allow Entry:** ${request.allow_entry ? 'Yes' : 'No'}
      `;
      return this.markedCleanBody(content);
    },

    saveSmsMessage() {
      localStorage.setItem('smsMessage', this.smsMessage);
    },

    addPixie() {
      const pixieText = '\n\nPixie Team';
      const emailText =
        '\n\nTo reply, please send an email to communications@bigpropertymanagement.com';

      if (!this.smsMessage.includes(pixieText)) {
        this.smsMessage += pixieText;
      }

      if (!this.smsMessage.includes(emailText)) {
        this.smsMessage += emailText;
      }

      localStorage.setItem('smsMessage', this.smsMessage);
    },

    askPerm() {
      const permissionText =
        'Maintenance needs permission to enter your apartment or house to work on your maintenance items. Are you home, or can they enter in your absence?';

      this.smsMessage = permissionText;

      localStorage.setItem('smsMessage', this.smsMessage);
    },
    addChatBot() {
      const footerText =
        '\n\nPlease give https://tenantapp.bigtapapp.com a try on your phone. You can more easily request maintenance, pay rent, chat with us, and more— all from our app. Works on iPhone or Android. Stop by the office if you need help getting started.';

      if (!this.smsMessage.includes(footerText)) {
        this.smsMessage += footerText;
      }

      localStorage.setItem('smsMessage', this.smsMessage);
    },
    addLoginHelp() {
      const footerText =
        '\n\nTo login to your tenant portal, your username is your first and last name joined together, all lowercase, with no spaces or puctuation. \n\nyour password is your apartment door code.';

      if (!this.smsMessage.includes(footerText)) {
        this.smsMessage += footerText;
      }

      localStorage.setItem('smsMessage', this.smsMessage);
    },

    addRentNudge() {
      const footerText =
        '\n\nReminder that rent is due on the 1st. After close of business on the 5th, a $40 late fee applies. Please email us at communications@bigpropertymanagement.com to advise us of your payment intentions.';

      if (!this.smsMessage.includes(footerText)) {
        this.smsMessage += footerText;
      }

      localStorage.setItem('smsMessage', this.smsMessage);
    },

    addPayFail() {
      const footerText =
        '\n\nYour recent rent payment attempt did not go through. Please retry your payment or drop a check or money order in the dropbox at the front door.';

      if (!this.smsMessage.includes(footerText)) {
        this.smsMessage += footerText;
      }

      localStorage.setItem('smsMessage', this.smsMessage);
    },

    needForwarding() {
      this.smsMessage = '';
      const footerText =
        'Dear Pixie Properties tenant:\n\nWe need a forwarding address to send your security deposit refund to. Thank You! \n\nPixie Team\n\nPlease use communications@bigpropertymanagement.com.';

      if (!this.smsMessage.includes(footerText)) {
        this.smsMessage += footerText;
      }

      localStorage.setItem('smsMessage', this.smsMessage);
    },

    clearText() {
      this.smsMessage = '';
      localStorage.removeItem('smsMessage');
    },

    bulkSMS() {
      // Phase 3: already sending — cancel bulk SMS
      if (this.bulkSMSactive) {
        this.bulkSMSactive = false;
        this.bulkSMSlist = [];
        this.smsMessage = '';
        this.clearSmsSelectionMode();
        localStorage.removeItem('smsMessage');
        localStorage.setItem('bulkSMSactive', 'false');

        const request = indexedDB.open('smsDatabase', 1);
        request.onsuccess = () => {
          const db = request.result;
          if (!db.objectStoreNames.contains('smsRecipients')) {
            return;
          }
          const transaction = db.transaction(['smsRecipients'], 'readwrite');
          const store = transaction.objectStore('smsRecipients');
          store.clear();
        };
        return;
      }

      // Phase 1: enter multi-select mode (do not SMS yet)
      if (!this.smsSelectMode) {
        this.smsSelectMode = true;
        this.smsSelectionList = [];
        this.selectedTileIndex = null;
        this.togglePanel('all');
        return;
      }

      // Phase 2: start bulk SMS over the selected cards
      if (this.smsSelectionCount === 0) {
        // Nothing selected — exit select mode
        this.clearSmsSelectionMode();
        return;
      }

      this.startBulkSmsFromList(this.smsSelectionList);
    },

    handleDocumentClick() {
      // No need to handle in document listener as we have a local handler
    },

    handlePageClick() {
      // Check if any panel is open
      const anyPanelOpen =
        this.showPhone ||
        this.showSMS ||
        this.showNote ||
        this.showWorkOrder ||
        this.showPayments ||
        this.showEmailForm ||
        this.showEmailViewer;

      if (!anyPanelOpen) return; // Return early if no panel is open

      // Check if click was outside a subpanel
      const isClickOutsidePanel =
        !event.target.closest('.subpanel-form') &&
        !event.target.closest('.icons-bar') &&
        !event.target.closest('.icon-item');

      if (isClickOutsidePanel) {
        // Close all panels
        this.showPhone = false;
        this.showSMS = false;
        this.showNote = false;
        this.showWorkOrder = false;
        this.showPayments = false;
        this.showEmailForm = false;
        this.showEmailViewer = false;

        // If bulk SMS is active, keep the selected tile
        if (!this.bulkSMSactive) {
          this.selectedTileIndex = null;
        }
      }
    },

    openMap() {
      // Check if a person is selected
      if (
        this.selectedTileIndex === null ||
        this.selectedTileIndex === undefined
      ) {
        this.updateFooterMessage('Please select a contact first');
        return;
      }

      const selectedPerson = this.filteredPeople[this.selectedTileIndex];

      if (!selectedPerson || !selectedPerson.Address) {
        this.updateFooterMessage('No address available for selected contact');
        return;
      }

      const address = selectedPerson.LongAddress;
      console.log('address:', address);

      // URL encode the address for Google Maps
      const encodedAddress = encodeURIComponent(address);

      // Detect platform
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      isAndroid || isIOS;

      if (isAndroid) {
        // For Android, use geo: URI scheme first (opens in Maps app), then fallback
        const geoUrl = `geo:0,0?q=${encodedAddress}`;
        const webUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}&map_action=map&basemap=hybrid`;

        // Try geo: scheme first
        window.location.href = geoUrl;

        // Fallback to web version after a short delay if Maps app doesn't open
        setTimeout(() => {
          window.open(webUrl, '_blank');
        }, 1500);
      } else if (isIOS) {
        // For iOS, use comgooglemaps: scheme
        const mapsAppUrl = `comgooglemaps://?q=${encodedAddress}&maptype=hybrid`;
        const webUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}&map_action=map&basemap=hybrid`;

        // Try to open Google Maps app first
        const link = document.createElement('a');
        link.href = mapsAppUrl;
        link.click();

        // Fallback to web version after a short delay if app doesn't open
        setTimeout(() => {
          window.open(webUrl, '_blank');
        }, 1000);
      } else {
        // On desktop, open in new tab with satellite view
        const webUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}&map_action=map&basemap=hybrid`;
        window.open(webUrl, '_blank');
      }

      this.updateFooterMessage(`Opening map for ${address}`);
    },
  },

  watch: {
    filteredPeople(newFilteredPeople) {
      if (newFilteredPeople.length === 1) {
        this.$nextTick(() => {
          this.selectCard(null, null, 0);
        });
      }
    },

    showWorkOrder(newVal) {
      if (newVal) {
        this.fetchWorkOrders(this.filteredPeople[this.selectedTileIndex].id);
      }
    },

    showEmailViewer(newVal) {
      if (newVal) {
        // Only fetch communications if a tile is selected
        if (
          this.selectedTileIndex !== null &&
          this.selectedTileIndex !== undefined &&
          this.filteredPeople.length > 0
        ) {
          this.fetchRecentCommunications();
        } else {
          console.warn('Cannot fetch email communications: No person selected');
          // Optionally close the viewer or show a user-friendly message
          // this.showEmailViewer = false;
        }
      }
    },

    showPhone(newVal) {
      if (newVal)
        this.fetchContactLogs(this.filteredPeople[this.selectedTileIndex].id);
    },
  },
};
</script>

<style scoped>
.people-page {
  /* margin-left: 5px; */
  padding: 0px;
  width: 100%;
  max-width: 440px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f0f0f0;
}

.title-bar {
  background: #a080a8;
  color: #fff;
  font-size: 1.4em;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
}

.title-buttons {
  display: flex;
  gap: 5px;
}

.back-button,
.home {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #e1dede;
  color: #eee;
  background: #907793;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.back-button {
  font-size: 0.7em;
}

.home {
  font-size: 0.6em;
}

.search-bar {
  margin-top: 5px;
  font-weight: bold;
  font-size: 0.9em;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}

.search-bar input,
.subpanel-form input {
  height: 28px;
  width: 110px;
  border-radius: 7px;
  border-color: #e1e1e1;
  margin-right: 2px;
  outline: none;
  padding-bottom: rpx;
}

.search-actions {
  display: flex;
  align-items: center;
}

.search-bar button {
  height: 32px;
  border-radius: 6px;
  padding: 4px;
  border-color: #ccc;
  background-color: #ccc;
  margin-left: 1px;
  border: 1px solid #aaa;
  min-width: 35px;
  margin-right: 3px;
}

.count-container {
  display: flex;
  align-items: center;
  margin-left: 3px;
}

.filter-buttons {
  display: flex;
  margin-top: 10px;
  align-items: flex-end;
  gap: 5px;
  width: 89%;
  margin-bottom: 8px;
}

.sms-filter-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.filter-buttons button {
  width: 60px;
  height: 40px;
  margin-right: 5px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background: #cccccc;
}

.separator {
  width: 1px;
  height: 30px;
  background-color: #ccc;
  margin: 0 5px;
}

/* Fix for FontAwesome icons in buttons */
.title-bar button i,
.search-bar button i,
.filter-buttons button i,
.email-form-buttons button i,
.subpanel-form button i {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.content-wrapper {
  padding-left: 10px;
  width: 93%;
  margin-left: 11px;
  display: flex;
  flex-direction: column;
  /* height: calc(100vh - 25px); */
  /* max-width: 420px; */
  /* margin: 4px; */
  /* box-shadow: 7px 5px 13px 2px rgba(0, 0, 0, 0.25); */
  padding: 8px;
  /* margin-left: 12px; */
  padding-left: 12px;
  /* border-radius: 5px; */
  height: 100vh;
  height: 100dvh;
  padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
}

.table-container {
  position: relative;
  width: 100%;
  user-select: none;
  margin-top: 12px;
}

.table-header {
  overflow: hidden; /* Prevents scrollbar on the header */
  padding-right: 15px;
  margin-top: 8px;
}

.table-header i {
  padding-left: 4px;
}

.table-body {
  max-height: 600px; /* Set a height for the scrollable area */
  overflow-y: scroll; /* Enables vertical scrolling */
  display: block; /* Makes the body a block element for separate scrolling */
}

.table-body table,
.table-header table {
  width: 100%; /* Ensures the table takes the full width of its container */
  border-collapse: collapse;
  font-size: 9pt;
  border: 0;
}

th,
td {
  text-align: left;
  padding: 4px; /* Add padding for better spacing */
  border-bottom: 0.1em solid #e4e4e4;
  border-left: 1pt solid #ccc;
}

th {
  min-width: 50px; /* Sets a minimum width for headers */
}

thead {
  background-color: #888;
  z-index: 1;
  font-size: 1.1em;
  position: sticky; /* Keeps the header sticky */
  top: 0; /* Sticks the header to the top of the container */
}

tbody tr {
  table-layout: auto; /* Allows columns to adjust based on content and width settings */
  cursor: pointer;
}

.selected-row {
  background-color: #baa1bd !important; /* Highlight selected row */
  /* color: #eee; */
}

.odd-row {
  background-color: #ddd; /* Example alternating row color */
}

.even-row {
  background-color: #ffffff;
}

.is-expired {
  color: #5f53c1a1;
  font-size: 1.1em;
}

.search-input {
  border-radius: 4px;
}

label {
  margin-left: 10px;
}

.date-picker {
  width: 100px !important;
}

.count {
  font-weight: normal;
}

.sum {
  font-weight: normal;
}

.overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* small dialog */
.small-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.small-dialog-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 14px 8px 7px 2px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  width: 400px;
}

.small-dialog-buttons button {
  margin: 10px;
  padding: 10px 20px;
  background-color: #a080a8;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.small-dialog-buttons button:hover {
  background-color: #a080a8;
}

.hint {
  font-weight: normal;
  font-size: 0.9em;
  font-style: italic;
}

.property {
  text-decoration: underline;
  text-decoration-color: #aaa;
  text-decoration-thickness: 1pt;
}

.click-target {
  width: 32px;
  height: 20px;
  margin: -5px;
}

.active-person {
  color: #111;
  background: #fff !important;
}

.active-class {
  background: #a080a8 !important;
}

.active-note {
  position: fixed;
  top: 20vh;
  left: 50%;
  margin-left: 5px;
  transform: translateX(-50%);
  background-color: rgba(44, 44, 44, 0.85);
  color: white;
  padding: 12px 15px;
  border-radius: 8px;
  font-size: 0.8em;
  width: 78%;
  max-height: 80px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  animation: fadeOut 6s ease-in-out;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.clear-button {
  margin-left: -4px;
  color: #a080a8;
}

.contact-tile {
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #b7b1b1;
  margin-bottom: 6px;
  font-size: 0.8em;
  width: 85%;
  background: #e1e1e1;
  box-shadow: 4px 0px 7px 1px rgba(0, 0, 0, 0.2);

  position: relative;
}

.tiles-container {
  height: 27vh;
  overflow-y: auto;
  margin-top: 6px;
  box-sizing: border-box;
  scroll-padding-bottom: calc(84px + env(safe-area-inset-bottom, 0px));
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.tile-row {
  margin-bottom: 4px;
  margin-left: 4px;
  color: #333;
}

.tile-row.tile-name {
  margin-left: 2px;
}

.tile-row.tile-email {
  width: 90%;
  height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tile-name {
  font-weight: bold;
  color: #896791;
  font-size: 1.3em;
}

.refresh-button {
  margin-left: 5px;
  border-radius: 5px;
  color: #7f6785;
}

.icons-bar {
  font-size: 1.2em;
  height: 38px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 10px;
  background-color: #434343;
  padding: 5px;
  border-radius: 5px;
  width: 86%;
  color: #eee;
  border: 1px solid #fff;
  box-shadow: 7px 8px 7px 2px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 10px; /* Space between each icon item */
}

.icon-item {
  text-align: center;
}

.icon-label {
  display: block;
  font-size: 9px; /* Size of the label text */
  color: #fff; /* Color of the label text */
}

.contact-tile {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.selected-tile {
  border: 2px solid lightgreen;
}

/* Beats .active-person { background: #fff !important } */
.contact-tile.sms-selected-tile {
  background: #e8dcec !important;
}

.sms-select-button {
  position: relative;
}

.sms-select-count {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #2f5fd0;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  pointer-events: none;
}

.active-sms .sms-select-count {
  background: #fff;
  color: #6e5875;
}

.subpanel-form {
  position: absolute;
  top: 41vh;
  border: 1px solid #9f9f9f;
  margin-top: 10px;
  background-color: #a080a8;
  padding: 15px;
  border-radius: 5px;
  width: 75%;
  /* max-width: 335px; */
  height: 386px;
  box-shadow: 5px 6px 12px 2px rgba(0, 0, 0, 0.2);
  padding-top: 5px;
  /* overflow-x: hidden; */
}

.markdown-preview {
  margin-top: 10px;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  background-color: #ffffff;
}

.email-form-buttons {
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
  gap: 10px;
}

.subpanel-form input {
  height: 25px;
  width: 85%;
  border-radius: 4px;
  border: 1px solid #ddd;
  margin-right: 5px;
}

.subpanel-form textarea {
  min-height: 125px;
  max-height: 125px;
  width: 94%;
  border-radius: 4px;
  border-color: #ccc;
  font-size: 1.1em;
  margin-top: 8px;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.subpanel-form textarea::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

.markdown-preview {
  margin-top: 10px;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: 125px;
  max-height: 125px;
  width: 94%;
  border-radius: 4px;
  border-color: #ccc;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.markdown-preview::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

.email-search-bar {
  margin-top: 8px;
  margin-bottom: 8px;
}
.email-form-buttons {
  width: 84%;
}

.email-form-buttons button {
  color: #fff;
  background: #a080a8;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #ddd;
}

.email-viewer {
  font-size: 0.8em;
  min-height: 375px;
  max-width: 80%;
}

.email-viewer .helper-text {
  position: absolute;
  bottom: 9px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 1.1;
  color: #f1eaea;
}

.email-viewer .inner-wrapper,
.work-orders .inner-wrapper {
  width: calc(75vw + 5px);
  overflow-y: scroll;
  overflow-x: hidden;
  max-width: 340px;
  height: 35vh;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.email-viewer .inner-wrapper::-webkit-scrollbar,
.work-orders .inner-wrapper::-webkit-scrollbar {
  display: none;
}

.email-card {
  border: 1px solid #aaa;
  border-radius: 5px;
  width: 72vw;
  max-width: 305px;
  margin: 1px;
  padding: 4px;
  margin-bottom: 8px;
  background: #ededed;
  word-wrap: break-word;
  position: relative;
}

.reply-icon {
  position: absolute;
  top: 8px;
  right: 10px;
  color: #888;
  cursor: pointer;
  font-size: 1.5em;
}

.reply-icon:hover {
  color: #666;
}

.clear-search {
  height: 27px;
  border: 1px solid #b1afaf;
  border-radius: 5px;
  width: 32px;
  color: #aaa;
}

.phone-number {
  font-size: 1.2em;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
}

.sms-message {
  margin-top: 10px;
  margin-bottom: 10px;
}

.subpanel-form button {
  color: #fff;
  background: #a080a8;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #ddd;
  height: 32px;
}

.contact-log-table {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #d5d5d5;
  margin-top: 10px;
  height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
}

.contact-log-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.75em;
  padding-top: 8px;
}
.odd-row {
  background-color: #f9f9f9;
}

.even-row {
  background-color: #e8e8e8;
}

.contact-log {
  display: flex;
  align-items: center;
}

.contact-log-cell {
  flex-shrink: 0;
  width: 150px; /* Adjust the width as needed */
  padding: 5px;
}

.timestamp {
  width: 110px; /* Example width for timestamp */
}

.type {
  width: 55px; /* Example width for contact type */
}

.user {
  width: 122px; /* Example width for display name */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-log-title {
  margin-top: 15px;
  font-size: 0.85em;
  font-weight: bold;
  margin-bottom: -5px;
  color: #ffffff;
}

.tile-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tile-name-main {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.person-flag {
  flex: 0 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  box-sizing: border-box;
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  padding: 0;
  border: 1px solid #8a8a8a;
  border-radius: 50%;
  background: transparent;
  color: #555;
}

.person-flag-on {
  background: #d4edda;
  border-color: #28a745;
  color: #155724;
}

.activity-time {
  font-size: 0.8em;
  font-weight: normal;
  font-family: monospace;
  color: #907793;
  margin-right: 5px;
}

.maint-tile {
  font-size: 0.75em;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #f9f9f9;
  width: 91%;
  border-radius: 5px;
  padding-top: 0;
}

.activity-icon {
  font-size: 20px;
  color: #d5d4d4;
  position: absolute;
  top: 29px;
  right: 18px;
}

.filter-buttons button {
  width: 60px;
  height: 40px;
  margin-right: 5px;
  border-radius: 5px;
}

.filter-buttons i {
  color: rgb(160, 128, 168) !important;
  font-size: 1.5em;
}

.active-filter {
  background-color: #a080a8 !important;
}

.active-filter i {
  color: #fff !important;
}

.active-sms {
  background-color: #a080a8 !important;
}
.active-sms i {
  color: #fff !important;
}

.response-footer {
  font-size: 0.8em;
  margin-top: -8px;
  margin-bottom: 6px;
  color: rgb(123, 123, 243);
  text-decoration: underline;
  display: flex;
  flex-direction: column;
}

.button-row {
  display: flex;
  justify-content: space-between; /* Distributes space evenly between buttons */
  align-items: center; /* Aligns items vertically centered */
  margin-top: 6px;
}
.response-button {
  flex: 1 0 22%;
  margin-right: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 4px;
  height: 50px !important;
  font-size: 0.9em;
}

.response-button:disabled {
  opacity: 0.75;
  cursor: wait;
}

.floating-notification {
  max-width: 330px;
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #a080a8;
  color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  animation: fadeInOut 12s ease-in-out;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  90% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}
.contact-log-message {
  font-size: 0.9em;
  color: #333;
  margin-top: -165px;
  padding: 8px;
  line-height: 1.5em;
  background: #fff;
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;
}

.tile-address {
  width: 85%;
}

.pet-icon {
  margin-left: 4px;
  font-size: 1.15em;
}

.specs-text {
  font-weight: bold;
  font-size: 0.9em;
}

.utility-inclusions {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-top: 3px;
  align-items: center;
  height: 20px;
  min-height: 20px;
}

.utility-label {
  font-size: 0.7em;
  color: #666;
  margin-right: 5px;
  margin-left: 5px;
  font-weight: normal;
}

.utility-tag {
  font-size: 0.75em;
  background-color: #e8e8e8;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 2px 4px;
  width: 30px;
  text-align: center;
  color: #555;
}

.utility-none {
  font-size: 0.7em;
  color: #888;
  font-style: italic;
}

/* Pets Dialog */
.pets-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pets-dialog {
  background: #fff;
  border-radius: 10px;
  padding: 18px 20px;
  width: 85%;
  max-width: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.pets-dialog-title {
  font-size: 1.1em;
  font-weight: bold;
  color: #333;
  margin-bottom: 2px;
}

.pets-dialog-subtitle {
  font-size: 0.8em;
  color: #888;
  margin-bottom: 14px;
}

.pets-dialog-body .pet-info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.pets-dialog-body .pet-field {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pets-dialog-body .pet-field label {
  font-size: 0.85em;
  white-space: nowrap;
  color: #555;
}

.pets-dialog-body .pet-count-input {
  width: 40px;
  padding: 6px 4px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1em;
  text-align: center;
  height: 32px;
  box-sizing: border-box;
  appearance: textfield;
  -moz-appearance: textfield;
}

.pets-dialog-body .pet-count-input::-webkit-outer-spin-button,
.pets-dialog-body .pet-count-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.pets-dialog-body .pet-names-field {
  flex: 1;
}

.pets-dialog-body .pet-names-input {
  flex: 1;
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9em;
  height: 32px;
  box-sizing: border-box;
}

.pets-dialog-body .pet-temperament-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #ddd;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1em;
  transition: background-color 0.2s;
}

.pets-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.pets-dialog-footer button {
  padding: 8px 22px;
  border: none;
  border-radius: 6px;
  font-size: 0.9em;
  cursor: pointer;
}

.pets-dialog-footer button:first-child {
  background: #a080a8;
  color: #fff;
}

.pets-dialog-footer button:last-child {
  background: #e0e0e0;
  color: #333;
}

.tenant-bal {
  display: inline-block;
  margin-left: 6px;
  padding: 0 6px;
  border-radius: 4px;
  border: 1px solid;
}

.tenant-bal-credit {
  background: #d4edda;
  color: #155724;
  border-color: #28a745;
}

.tenant-bal-owed {
  background: #f6e6e8;
  color: #8a5a60;
  border-color: #d4b0b4;
}
</style>
